/*
 *
 * Track events
 * Pushes custom dataLayer events based on data attributes:
 * - data-track-click="eventName": link clicks within the element
 * - data-track-submit="eventName": submits of the form
 * An optional data-track-title is sent along as sectionTitle.
 *
 */
const normalizeText = text => (text || '').replace(/\s+/g, ' ').trim();

const pushEvent = data => window.dataLayer?.push(data);

document.addEventListener('click', e => {
  // Prevented clicks are ignored, e.g. Flickity prevents clicks after dragging a slider
  if (e.defaultPrevented) return;

  const link = e.target.closest('a[href]');
  const section = link?.closest('[data-track-click]');
  if (!section) return;

  pushEvent({
    event: section.dataset.trackClick,
    sectionTitle: normalizeText(section.dataset.trackTitle),
    linkText: normalizeText(link.textContent),
    linkUrl: link.href,
  });
});

document.addEventListener('submit', e => {
  const form = e.target.closest('[data-track-submit]');
  if (!form) return;

  pushEvent({
    event: form.dataset.trackSubmit,
    sectionTitle: normalizeText(form.dataset.trackTitle),
    searchTerm: normalizeText(form.querySelector('[name$="[search]"]')?.value),
  });
});
